export const PRODUCT_PAGE_SIZE = 15
export const POST_PAGE_SIZE = 5
export const SAVE_SEARCH = 1
export const NO_SAVE_SEARCH = 1
